import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('attribute');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(vuexContext, attributeGroupId) {
        return axios.$get('/admin/attributes', {
            params: { attributeGroupId }
        });
    }
};
